export const isPositiveNumber = (val?: number | null): val is number =>
  typeof val === 'number' && val >= 0;
